import React, { useCallback, useEffect, useState } from 'react';
import { Loader, AlertCircle } from 'lucide-react';
import API from '../../../api/API';
import { validaStatistiche } from './util';

/**
 * Il caricamento dei dati di una edizione, con la sua validazione.
 *
 * Lo usa il solo `EdizioneLayout`: il riepilogo e le sue viste sono rotte figlie e ricevono le
 * statistiche già pronte dall'Outlet. Resta un modulo a sé perché il layout è un componente di
 * instradamento, e perché la sequenza chiamata → controllo dell'esito → validazione del DTO si
 * legge e si cambia meglio fuori dal suo render.
 */
export const useDatiEdizione = (idEdizione) => {
  const [statistiche, setStatistiche] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [fuoriArchivio, setFuoriArchivio] = useState(false);

  const carica = useCallback(async () => {
    setLoading(true);
    setError(null);
    setFuoriArchivio(false);
    try {
      const response = await API.statistiche.full(idEdizione);
      if (!response.isSuccess) {
        // 401 e 403 qui non sono un errore da riprovare: sono la risposta del server a una
        // edizione non pubblica, che nell'archivio pubblico semplicemente non c'e'. Chi ha il
        // permesso di leggerla passa e arriva al 200, e vede il banner sui dati parziali.
        if (response.status === 401 || response.status === 403) {
          setFuoriArchivio(true);
          setStatistiche(null);
          return;
        }
        setError(response.errorMsg || 'Errore nel caricamento delle statistiche');
        setStatistiche(null);
        return;
      }
      const validazione = validaStatistiche(response.data);
      if (!validazione.valido) {
        setError(`Dati non validi: ${validazione.errore}`);
        setStatistiche(null);
        return;
      }
      setStatistiche(response.data);
    } catch (err) {
      setError(err.message || 'Errore nel caricamento delle statistiche');
      setStatistiche(null);
    } finally {
      setLoading(false);
    }
  }, [idEdizione]);

  useEffect(() => { carica(); }, [carica]);

  return { statistiche, loading, error, fuoriArchivio, ricarica: carica };
};

export const Caricamento = () => (
  <div className="statistiche-loading">
    <Loader className="statistiche-loading-icon" />
    <h3 className="statistiche-loading-title">Caricamento statistiche...</h3>
  </div>
);

export const Errore = ({ messaggio, onRiprova }) => (
  <div className="statistiche-error">
    <AlertCircle className="statistiche-error-icon" />
    <h3 className="statistiche-error-title">Errore nel caricamento</h3>
    <p className="statistiche-error-text">{messaggio}</p>
    <button onClick={onRiprova} className="statistiche-retry-button">Riprova</button>
  </div>
);
